import { render, staticRenderFns } from "./RekapSurat.vue?vue&type=template&id=63d5fffb&scoped=true"
import script from "./RekapSurat.vue?vue&type=script&lang=js"
export * from "./RekapSurat.vue?vue&type=script&lang=js"
import style0 from "./RekapSurat.vue?vue&type=style&index=0&id=63d5fffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d5fffb",
  null
  
)

export default component.exports